import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import cdiceimage from '../../assets/images/portfolio_croulette.png';
import CRouletteContant from '../other_language/productcard/CRouletteContant';
export default function CRouletteCard() {
  return (
    <a href='https://c-roulette.info/'>
    <Card>
      <CardActionArea>
        <CardMedia
          component="img"
          height="140"
          image={cdiceimage}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            C-Roulette
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <CRouletteContant/>
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </a>
  );
}
